<template>
  <div>
    <div id="shopping-cart" v-if="drugs">
      <button type="button" class="btn btn-default" @click="shopCartModal = true">
        <span class="glyphicon glyphicon-shopping-cart"></span> Drug Allocation
      </button>
    </div>

    <modal v-if="shopCartModal" @close="shopCartModal = false">
    <div slot="header">
      <h3>Allocate Drugs</h3>
      <input type="text" v-model="filter" class="form-control" placeholder="Search...">
    </div>
    <div slot="body">
      <div v-for="(drug_group, groupIndex) in drugs" :key="drug_group.name">

        <h3 @click="toggleGroup(groupIndex)">
          {{ drug_group.name }}
        </h3>
        <div v-for="(drug, drugs_iteration_index) in filteredDrugs(drug_group.drugs)" :key="drug.pk">
          <div class="clearfix drug_group"  :class="{ show: shouldShowGroup(groupIndex),  hide: !shouldShowGroup(groupIndex)  }" :style="{ width: 400 + widthForRow(farms) + 'px' }">

            <div v-if="drug.inactive == false || drug.amount_used_last_season > 0">
              <div class="farm-fields">
                <h4 v-if="drugs_iteration_index == 0">
                  {{ lastYearLabel(drug_group.name)}}
                </h4>
                <div class="form-group">
                  <label> {{ drug.name }} </label>
                  <input type="number" :value="drug.amount_used_last_season" class="form-control" disabled>
                </div>
              </div>

              <div v-for="farm in farms" class="farm-fields" :key="farm.id">
                <h4 v-if="drugs_iteration_index == 0">
                  {{ thisYearLabel(drug_group.name) }} {{ farm.farm_label }}
                </h4>

                <div v-if="drug_group.pk == '15' && getFieldValue(`farm_${farm.id}_drug_${drug.pk}-is_pre_allocation`)" class="form-group" >
                  <label> {{ drug.name }} </label>
                  <div class="row">
                    <div class="col-md-6">
                      <number-input label=""
                                    :field-name="`farm_${farm.id}_drug_${drug.pk}-par_qty`"
                                    :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                                    :placeholder="[ drug.inactive ? 'Disabled' : '' ]">
                                    <!-- :min="getFieldValue(`farm_${farm.id}_drug_${drug.pk}-original_par_qty`)" -->
                      </number-input>

                      <span class="text-danger">
                        Expires {{ new Date(getFieldValue(`farm_${farm.id}_drug_${drug.pk}-par_end_date`)) | moment("DD-MM-YYYY") }}
                      </span>
                    </div>

                    <div class="col-md-6">
                      <number-input label=""
                                    :field-name="`farm_${farm.id}_drug_${drug.pk}_future-par_qty`"
                                    :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                                    :placeholder="[ drug.inactive ? 'Disabled' : '' ]">
                      </number-input>

                      <span class="text-danger">
                        {{ futureAllocationDates(new Date(getFieldValue[`farm_${farm.id}_drug_${drug.pk}-par_end_date`])) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="form-group">
                  <label> {{ drug.name }} </label>
                  <number-input label=""
                                :field-name="`farm_${farm.id}_drug_${drug.pk}-par_qty`"
                                :disabled="drug.inactive || isReadOnly || drug.disallow_allocations"
                                :placeholder="[ drug.inactive ? 'Disabled' : '' ]">
                  </number-input>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../../Modal'
import { mapGetters } from 'vuex'
import { CustomInputs } from '@/components/inputs'

export default {
  name: 'DrugAllocationCart',
  props: [
    'drugs',
    'farms',
  ],
  components: {
    ...CustomInputs,
    Modal,
  },
  data() {
    return {
      shopCartModal: false,
      filter: '',
      groupVisibility: {},
    }
  },
  methods: {
    thisYearLabel: function (drugGroupName)
    {
      if (drugGroupName == 'Scour Vaccines')
      {
        return 'Allocations for next season (Jun-Sep) for'
      }
      return 'Allocations for next season for'
    },
    lastYearLabel: function (drugGroupName)
    {
      if (drugGroupName == 'Scour Vaccines')
      {
        return 'Qty purchased since June'
      }

      return 'Qty purchased since July'
    },
    widthForRow(farms)
    {
      return farms.length * 400;
    },
    farmAllocations: function (farmId)
    {
      return this.getFieldValue(`farm_${farmId}-allocations`)
    },
    toggleGroup: function (groupIndex)
    {
      this.$set(this.groupVisibility, groupIndex, !this.groupVisibility[groupIndex])
    },
    shouldShowGroup: function (groupIndex)
    {
      return this.searching || Boolean(this.groupVisibility[groupIndex]);
    },
    filteredDrugs: function(drugs)
    {
      return (this.filter)
        ? drugs.filter(drug => drug.inactive == false && drug.name.toLowerCase().includes(this.filter.toLowerCase()))
        : drugs.filter(drug => drug.inactive == false)
    },
    futureAllocationDates: function(parEndDate)
    {
      let futureAllocationStartDate

      let today = new Date()

      if (parEndDate > today) {
        futureAllocationStartDate = this.$moment(parEndDate).add('1', 'days')
      } else {
        futureAllocationStartDate = this.$moment(today)
      }
      return futureAllocationStartDate.format("DD-MM-YYYY") + '  -  ' + futureAllocationStartDate.add('4', 'months').format("DD-MM-YYYY")
    },
  },
  computed: {
    ...mapGetters('currentConsult', [
      'isReadOnly',
      'getFieldValue',
    ]),
    searching: function ()
    {
      return Boolean(this.filter)
    }
  }
};
</script>

<style scoped>
#shopping-cart {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
